import { queryOptions } from "@tanstack/react-query";

import { normalizeRequestError } from "@/lib/errors";
import { request } from "@/lib/request";
import { User } from "@/lib/types";

/**
 * Shared key+fn for /user/info so the boot prefetch (main.tsx) and
 * UserProvider's useQuery dedupe into one request. The token stays in the key
 * to match the pre-existing cache entry format (see profilesQuery.ts for the
 * tokenless convention new queries should use).
 */
export const userQueryOptions = (accessToken: string | null) =>
  queryOptions({
    queryKey: ["user", accessToken],
    queryFn: async (): Promise<User> => {
      const res = await request
        .get(`/user/info`)
        .catch(normalizeRequestError("Failed to load user profile"));

      return res.data.data;
    },
  });
